'use strict';
import {module} from '../app';

module.controller('ScheduledCtrl', [
    '$scope', '$location', function ($scope, $location) {

      $scope.vm = {
        goToWorklist: function () {
          $location.path('/root/worklist');
        }
      };
    }
  ]);



// WEBPACK FOOTER //
// ./src/scripts/controllers/scheduled.js